module.exports = __webpack_public_path__ + "img/back.6a92ca27.png";